// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().name("encounter_id"),
  pulseIndex: __t.u32().name("pulse_index"),
  log: __t.byteArray(),
  events: __t.byteArray(),
  ended: __t.option(__t.u8()),
});
